import {
    createStyles,
    makeStyles,
    Theme,
} from '@bb-ui/react-library/dist/components/styles';
import { ListNavVariant } from './ListNav.types';
import { illuminateColors } from '../../utilities/sharedStyles';

// Use to override the classes for ListItem. See: https://material-ui.com/api/list-item/#css
const styles = (theme: Theme) => {
    const rowLabel = {
        fontSize: theme.typography.pxToRem(15),
    };
    const rowLabelSelector = '& > div > span';

    return createStyles({
        root: {
            paddingTop: theme.spacing(2),
            paddingBottom: theme.spacing(2),
            '&:hover': {
                textDecoration: 'none',
            },
        },
        gutters: {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
        },
        button: (props: {
            listNavVariant: ListNavVariant;
            forceEnableHover?: boolean;
        }) => {
            switch (props.listNavVariant) {
                case 'global':
                    return {
                        color: illuminateColors.navText,
                        ...(props.forceEnableHover
                            ? { pointerEvents: 'auto !important' as any }
                            : {}),
                        [rowLabelSelector]: {
                            ...rowLabel,
                            fontWeight: theme.typography.fontWeightSemiBold,
                        },
                        '&:hover, &:focus': {
                            textDecoration: 'none',
                            backgroundColor: theme.palette.background.b3,
                            '& .primary-text': {
                                textDecoration: 'none',
                            },
                        },
                        '&.active': {
                            backgroundColor: illuminateColors.navSurfaceActive,
                            borderLeft: `4px solid ${illuminateColors.brandGreen}`,
                        },
                        '&.active > div': {
                            color: illuminateColors.navTextActive,
                            position: 'relative',
                            left: '-4px',
                        },
                    };
                case 'secondary':
                    return {
                        color: illuminateColors.navText,
                        ...(props.forceEnableHover
                            ? { pointerEvents: 'visible !important' as any }
                            : {}),
                        '&:hover, &:focus': {
                            textDecoration: 'none',
                            backgroundColor: theme.palette.background.b3,
                            color: illuminateColors.navTextActive,
                            '& .primary-text': {
                                textDecoration: 'none',
                            },
                        },
                        [rowLabelSelector]: {
                            ...rowLabel,
                            fontWeight: theme.typography.fontWeightRegular,
                        },
                        '&.active > div': {
                            color: illuminateColors.navTextActive,
                        },
                        '&.active > div > span': {
                            fontWeight: theme.typography.fontWeightBold,
                        },
                    };
            }
        },
    });
};

const options = {
    name: 'ListNavItem-',
};

export const useStyles = makeStyles(styles, options);
